export const ARMS_FAIL_DETAIL_MAX_LEN = 200;

/** 截断 ARMS 自定义事件 fail_detail，避免超长 */
export function truncateArmsFailDetail(detail: string): string {
    const trimmed = detail.trim();
    if (trimmed.length <= ARMS_FAIL_DETAIL_MAX_LEN) {
        return trimmed;
    }
    return trimmed.slice(0, ARMS_FAIL_DETAIL_MAX_LEN);
}

/** 从 unknown 提取可上报的错误摘要 */
export function readArmsFailDetail(err: unknown): string | undefined {
    if (err instanceof Error && err.message.trim()) {
        const code = (err as Error & { businessCode?: number }).businessCode;
        if (code !== undefined) {
            return `businessCode:${code};${err.message}`;
        }
        return err.message;
    }
    if (typeof err === 'string' && err.trim()) {
        return err;
    }
    return undefined;
}
